import initializeAttachmentFullViewState from './initialization/initializeAttachmentFullViewState';
import setInlineAttachmentStatus from './setInlineAttachmentStatus';
import setOngoingAction from './setOngoingAction';
import ActionType from '../schema/ActionType';
import AttachmentState from '../schema/AttachmentState';
import InlineAttachmentStatus from '../schema/InlineAttachmentStatus';
import isAttachmentPartOfItem from '../utils/isAttachmentPartOfItem';
import isInlineAttachmentStateType from '../utils/isInlineAttachmentStateType';
import { setIsPlaceholderAttachment } from 'owa-attachment-data';
import addAndInitializeAttachments from 'owa-attachment-model-store/lib/actions/addAndInitializeAttachments';
import deleteAttachment from 'owa-attachment-model-store/lib/actions/deleteAttachment';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { ClientAttachmentId } from 'owa-client-ids';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import FileAttachment from 'owa-service/lib/contract/FileAttachment';
import ItemId from 'owa-service/lib/contract/ItemId';
import { action } from 'satcheljs/lib/legacy';
import {
    getTypeOfAttachment,
    TypeOfAttachment,
    SmimeAttachmentType,
} from 'owa-attachment-model-store';

/**
 * Updates the attachment store and attachment well after successful download
 */
export default action('updateSmimeAttachment')(function updateSmimeAttachment(
    attachmentState: AttachmentState,
    newAttachmentId: ClientAttachmentId,
    attachment: SmimeAttachmentType,
    attachmentFromServer: AttachmentType,
    itemId: ItemId
) {
    // Delete the attachment if it belongs to the compose item, else its part of parent item (r/R/f/d), skip and create new attachment
    isAttachmentPartOfItem(attachment, itemId) && deleteAttachment(attachmentState.attachmentId);

    const attachmentType = getTypeOfAttachment(attachment);

    // Replace attachment-id with smime prefix, since we will be sending it to S/MIME control
    attachment.AttachmentId = newAttachmentId;
    attachment.Name = attachmentFromServer.Name || attachment.Name;
    attachment.Size = attachmentFromServer.Size || attachment.Size;
    attachment.ContentType = attachmentFromServer.ContentType || attachment.ContentType;
    // When creating an attachment from an attachmentItemId, we need to update the type of the attachment
    // on the client to match the type of attachment that the server sent on the response.
    attachment.__type = attachmentFromServer.__type || attachment.__type;

    // Set content in attachmentType object in AttachmentStore
    if (attachmentType === TypeOfAttachment.Mail) {
        attachment.MimeContent = (<SmimeAttachmentType>attachmentFromServer).MimeContent;
    } else if (attachmentType === TypeOfAttachment.File) {
        attachment.Content = (<FileAttachment>attachmentFromServer).Content;
    }

    if (attachment.IsInline) {
        attachment.ContentId = attachmentFromServer.ContentId || attachment.ContentId;
    }

    addAndInitializeAttachments(
        [
            {
                attachmentId: newAttachmentId,
                attachment: attachment,
            },
        ],
        false /* isReadOnly */
    );

    attachmentState.attachmentId = newAttachmentId;
    if (isInlineAttachmentStateType(attachmentState)) {
        setInlineAttachmentStatus(
            attachmentState,
            InlineAttachmentStatus.CreateAttachmentSucceeded
        );
    } else {
        const attachmentModel = getAttachment(newAttachmentId);
        setIsPlaceholderAttachment(attachmentState, false);
        setOngoingAction(attachmentState, ActionType.None);
        // Reset strategy to reinitialize S/MIME attachments' strategy
        initializeAttachmentFullViewState(
            attachmentState,
            attachmentModel,
            false /* treatLinksAsAttachments */,
            []
        );
    }
});
